import React, { useState, useEffect, useLayoutEffect, useRef, useContext } from 'react';
import { GlobalContext } from 'context/userContext';

import { Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { DrawerHeader } from '@components/drawer-header';
import DropBoxSelector from '@components/dropbox-selector';
import TableExplorer from '@components/table-explorer/table_explorer';
import { AxiosInstance } from '@service/axios-instance';
import { Box, Modal, Typography, FormLabel, Switch, FormControlLabel, FormHelperText, Paper, useTheme, Divider, Button, Alert, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { MassUploadModal, Field } from '@components/mass-upload-modal';
import { useForm } from 'react-hook-form';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import * as S from './styles';
import { Password } from '@mui/icons-material';
import { saveCurrentOperationConfig, getCurrentOperationConfig } from '../operations-config/api';



interface FormData {
  'Login': string;
  'Name': string;
  'Senha': string,
  'Cartao': string,
  'Area': string;
  'Machines': string[];
  'Type': '0' | '1' | '2';
  'Active': 'true' | 'false';
}


export function UsersMachine() {


  const { operation, mainUser } = useContext(GlobalContext);
  const theme = useTheme();

  const canModify = mainUser?.roles?.some?.((role: string) => ['MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR'].includes(role));

  const [saveModalOpen, setsaveModalOpen] = useState<boolean>(false);
  const [massUploadModalOpen, setMassUploadModalOpen] = useState<boolean>(false);
  const [editModalOpen, seteditModalOpen] = useState<boolean>(false);
  const [usersDBVersion, setusersDBVersion] = useState(0);

  const [isNewUser, setIsNewUser] = useState<boolean>(false);
  const [clickedRow, setclickedRow] = useState<Record<string, any>>();
  const [table, setTable] = useState<any>(null);

  // Document states
  const [docFile, setDocFile] = useState<File | null>(null);
  const [docType, setDocType] = useState<string>('ASO');
  const [docTypeOther, setDocTypeOther] = useState<string>('');
  const [docValidade, setDocValidade] = useState<string>('');
  const [userDocs, setUserDocs] = useState<any[]>([]);
  const [downloadSelected, setDownloadSelected] = useState<string>('');
  const [isUploading, setIsUploading] = useState<boolean>(false);

  //form

  const { register, control, handleSubmit, formState: { errors }, reset, watch } = useForm<FormData>({
    defaultValues: {
      Senha: "*****",
      Cartao: "",
    },
  });

  const selectedType = watch("Type");

  const tableSaveRef = useRef<any>(null);
  const [machineIdOptions, setMachineIdOptions] = useState<string[]>([]);
  const [machineTypeOptions, setMachineTypeOptions] = useState<string[]>([]);
  const [accessMode, setAccessMode] = useState<string>('selected_machines');
  const [expirationCheckMode, setExpirationCheckMode] = useState<string>('disabled');

  useEffect(() => {
    async function loadConfig() {
      if (!operation) return;
      try {
        const currentOp = await getCurrentOperationConfig(operation);
        if (currentOp) {
          if (currentOp.USER_MACHINE_ACCESS_MODE) setAccessMode(currentOp.USER_MACHINE_ACCESS_MODE);
          if (currentOp.DOCUMENT_CONFIGURATION) setExpirationCheckMode(currentOp.DOCUMENT_CONFIGURATION);
        }
      } catch (e) {
        console.error("Could not load operation configs:", e);
      }
    }
    loadConfig();
  }, [operation]);


  useEffect(() => {
    getUsersMachineVersion();
    fetchEquipamentsList();
  }, []);

  function fetchEquipamentsList() {
    if (operation == null) return;

    AxiosInstance.post('/equipaments/get_equipaments?db=' + operation, {}, {
      withCredentials: true,
    })
      .then((response) => {
        const mIdOptions = new Set<string>();
        const mTypeOptions = new Set<string>();
        response.data.forEach((eq: any) => {
          if (eq.id) mIdOptions.add(String(eq.id));
          if (eq.tipo) mTypeOptions.add(String(eq.tipo));
        })
        console.log('mIdOptions:', Array.from(mIdOptions));
        console.log('mTypeOptions:', Array.from(mTypeOptions));

        setMachineIdOptions(Array.from(mIdOptions));
        setMachineTypeOptions(Array.from(mTypeOptions));
      })

      .catch(e => {

        if (e.response && e.response.status === 401) {
          console.warn("Unauthorized access (401). Redirecting to login or handling it.");
        } else {
          console.error("fetch equips error:", e);
          console.log("/fetch equips error");
        }

      });



  }



  function getUsersMachineVersion() {
    AxiosInstance.get('/users-machine/get_version?db=' + operation, {
      withCredentials: true,
    })
      .then((resVersion) => {
        setusersDBVersion(resVersion.data.version);
        if (resVersion.data.USER_MACHINE_ACCESS_MODE) {
          setAccessMode(resVersion.data.USER_MACHINE_ACCESS_MODE);
        }
        if (resVersion.data.DOCUMENT_CONFIGURATION) {
          setExpirationCheckMode(resVersion.data.DOCUMENT_CONFIGURATION);
        }
      })
      .catch(() => { console.log("get version error") });
  }

  function set_table_instance_cb(table_instance: any) {
    setTable(table_instance)
  }


  function row_modifier_open_cb(row_instance: Record<string, any>) {
    setclickedRow(row_instance);
    setIsNewUser(false);
    const original_data = row_instance.data()

    console.log("abrindo edit modal com", original_data)
    fetchUserDocs(original_data[1]);
    reset({
      "Active": original_data[0].toString(),
      "Login": original_data[1],
      "Type": original_data[2],
      "Name": original_data[3],
      "Area": original_data[4],
      "Machines": original_data[5],
      "Senha": "*****",
      "Cartao": original_data[7] || "",
    });
    seteditModalOpen(true);
  }

  const fetchUserDocs = async (login: string) => {
    if (!login || !operation) return;
    try {
      const response = await AxiosInstance.get(`/users-machine/documents/list?db=${operation}&login=${login}`, {
        withCredentials: true,
      });
      setUserDocs(response.data);
    } catch (error) {
      console.error("Error fetching user docs:", error);
    }
  };

  const handleFileUpload = async () => {
    const login = watch("Login");
    if (!login) {
      alert("Por favor, preencha o Login primeiro.");
      return;
    }
    if (!docFile || !docValidade) {
      alert("Por favor, selecione um arquivo e defina a validade.");
      return;
    }
    if (docFile.type !== 'application/pdf') {
      alert("Apenas arquivos PDF são permitidos.");
      return;
    }

    const typeToSave = docType === 'OUTROS' ? docTypeOther : docType;
    if (!typeToSave) {
      alert("Por favor, especifique o tipo de documento.");
      return;
    }

    setIsUploading(true);

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64String = reader.result;

      try {
        await AxiosInstance.post(`/users-machine/documents/upload?db=${operation}`, {
          login: login,
          type: typeToSave,
          validade: docValidade,
          file: base64String,
          file_name: docFile.name
        }, {
          withCredentials: true,
        });

        alert("Documento enviado com sucesso.");
        setDocFile(null);
        setDocValidade('');
        setDocTypeOther('');
        fetchUserDocs(login);
      } catch (error) {
        console.error("Error uploading document:", error);
        alert("Erro ao enviar documento.");
      } finally {
        setIsUploading(false);
      }
    };
    reader.readAsDataURL(docFile);
  };

  const handleFileDownload = async () => {
    if (!downloadSelected || !operation) return;

    try {
      const response = await AxiosInstance.get(`/users-machine/documents/download/${downloadSelected}?db=${operation}`, {
        withCredentials: true,
      });

      const { file_name, file_base64 } = response.data;

      const a = document.createElement('a');
      a.href = file_base64;
      a.download = file_name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading document:", error);
      alert("Erro ao fazer download do documento.");
    }
  };

  const onSubmit = (data: FormData) => {
    console.log("Atualizando tabela com", data);

    if (isNewUser) {
      if (table) {
        const existingLogins = table.column(1).data().toArray().map(String);
        if (existingLogins.includes(String(data["Login"]))) {
          alert(`Erro: Já existe um usuário com o login ${data["Login"]}.`);
          return;
        }

        const new_data = [
          data["Active"] == 'true',
          data["Login"],
          data["Type"],
          data["Name"],
          data["Area"],
          (String(data["Type"]) === '1' || String(data["Type"]) === '2') ? [] : data["Machines"],
          "",
          ""
        ];

        if ((data["Senha"] != "") && (data["Senha"] != "*****")) {
          console.log("configurando senha!");
          new_data[6] = data["Senha"];
        }

        if (data["Cartao"] != "*****") {
          console.log("configurando cartao!");
          new_data[7] = data["Cartao"];
        }

        table.row.add(new_data).draw();
      }
      else { alert("Erro ao carregar a tabela, tente novamente") }
    }
    else {
      if (clickedRow) {

        const originalLogin = clickedRow.data()[1];
        if (data["Login"] !== originalLogin && table) {
          const existingLogins = table.column(1).data().toArray().map(String);
          if (existingLogins.includes(String(data["Login"]))) {
            alert(`Erro: Já existe um usuário com o login ${data["Login"]}.`);
            return;
          }
        }

        const new_data = clickedRow.data();
        new_data[0] = data["Active"] == 'true'
        new_data[1] = data["Login"]
        new_data[2] = data["Type"]
        new_data[3] = data["Name"]
        new_data[4] = data["Area"]
        new_data[5] = (String(data["Type"]) === '1' || String(data["Type"]) === '2') ? [] : data["Machines"]


        console.log("SENHA", data["Senha"]);
        if ((data["Senha"] != "") && (data["Senha"] != "*****")) {
          console.log("mudando senha!");
          new_data[6] = data["Senha"];
        }

        if (data["Cartao"] != "*****") {
          console.log("mudando cartao!");
          new_data[7] = data["Cartao"];
        }

        clickedRow.data(new_data);
      }
    }

    seteditModalOpen(false)
  };

  return (
    <DrawerHeader
      title={"Usuarios de máquinas"}
    >
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2.5, md: 3 },
              bgcolor: 'background.paper',
              borderLeft: `6px solid ${theme.palette.primary.main}`,
              borderRadius: 2,
              mb: 1
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1.5, fontWeight: 600 }}>
                  CONTROLE DE ACESSO
                </Typography>
                <Typography variant="h4" fontFamily="Saira" fontWeight={900} color="text.primary">Gestão de Operadores</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                  Configure quais colaboradores possuem permissão de utilização nas máquinas. As chaves de acesso (senha/cartão) são sincronizadas de forma automática com as máquinas.
                </Typography>
              </Box>
              <Box sx={{ bgcolor: theme.palette.grey[100], p: 2, borderRadius: 2, border: `1px solid ${theme.palette.grey[300]}`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 600, textAlign: 'center', lineHeight: 1, mb: 0.5 }}>UV</Typography>
                <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold', textAlign: 'center', lineHeight: 1 }} id="users_db_version">{usersDBVersion}</Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>

        <Grid item display="flex" gap={2}>
          <S.Button onClick={() => {
            reset({
              "Active": "true",
              "Area": "",
              "Login": "",
              "Senha": "*****",
              "Cartao": "",
              "Machines": [],
              "Name": "",
              "Type": undefined,
            });
            setUserDocs([]);
            setDocFile(null);
            setDocValidade('');
            setDocTypeOther('');
            setDownloadSelected('');
            setIsNewUser(true);
            seteditModalOpen(true);
          }}
          >
            Novo Usuario
          </S.Button>

          <S.Button style={{ background: 'transparent', color: '#a51033', border: '1px solid #a51033', boxShadow: 'none' }} onClick={() => setMassUploadModalOpen(true)}>
            Importar Planilha
          </S.Button>
        </Grid>

        <Grid item>
          <S.Button onClick={() => setsaveModalOpen(true)}>{"Salvar Modificações"}</S.Button>
        </Grid>

      </Grid>

      {
        <TableExplorer 
          dbName={operation} 
          tableName={"users-machine"} 
          headerContent={
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              py: 0.5,
              px: 1.5,
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.default'
            }}>
              <InfoOutlinedIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
              <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
                Para editar ou remover usuarios, clique no usuario da lista.
              </Typography>
            </Box>
          }
          modifier_cb={canModify ? row_modifier_open_cb : undefined} 
          set_table_instance_cb={set_table_instance_cb} 
          savefuncRef={tableSaveRef} 
          visibleColumns={["active", "login", "type", "name", "area", "machines", "password", "rfid_uuid"]} 
          maskedColumns={["password"]} 
        />
      }

      {saveModalOpen && (
        <Modal open={saveModalOpen} onClose={() => setsaveModalOpen(false)}>
          <S.ModalContainer>
            <S.ModalContent>
              <Box
                maxWidth={300}
                justifyContent="center"
                display="flex"
                flexDirection="column"
                alignItems="center"
              >
                <Typography
                  variant="h5"
                  color="primary"
                  fontWeight={600}
                  textAlign="center"
                  mt={2}
                >
                  Tem certeza que deseja salvar as alterações?
                </Typography>
                <S.ButtonContainer>
                  <S.ButtonYes onClick={async () => {
                    try {
                      console.log("calling savetable ref")

                      const allRows = tableSaveRef.current?.getDataArray();
                      console.log("ALL ROWS", allRows);

                      const allData = allRows.map((row: any[]) => ({
                        active: row[0],
                        login: row[1],
                        type: String(row[2]), // to match schema expecting string
                        name: row[3],
                        area: row[4],
                        machines: row[5],
                        password: row[6],
                        rfid_uuid: row[7],
                      }));

                      await tableSaveRef.current?.saveTable({ 'users': allData });

                      // Fetch the actual version from the backend instead of assuming it bumped
                      AxiosInstance.get('/users-machine/get_version?db=' + operation, {
                        withCredentials: true,
                      }).then((resVersion: any) => {
                        setusersDBVersion(resVersion.data.version);
                      }).catch(() => { console.log("get version error after save") });

                      setsaveModalOpen(false);

                    } catch (err: any) {
                      console.error(err);
                      let errorMessage = err.message || "Erro desconhecido";
                      if (err.response?.data) {
                        if (typeof err.response.data === 'string') {
                          errorMessage = err.response.data.length < 200 ? err.response.data : errorMessage;
                        } else if (err.response.data.error || err.response.data.message) {
                          errorMessage = err.response.data.error || err.response.data.message;
                        }
                      }
                      alert(`Erro ao salvar a tabela:\n${errorMessage}`);
                    }

                  }}>
                    SIM
                  </S.ButtonYes>
                  <S.ButtonNo onClick={() => setsaveModalOpen(false)}>NÃO</S.ButtonNo>
                </S.ButtonContainer>
              </Box>
            </S.ModalContent>
          </S.ModalContainer>
        </Modal>
      )}

      {editModalOpen && (
        <Modal open={editModalOpen} onClose={() => seteditModalOpen(false)}>

          <S.ModalContainer>

            <Box sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 10,
            }}>
              <IconButton
                onClick={() => seteditModalOpen(false)}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                width: '100%',
                maxWidth: 1000,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '85vh',
                overflowY: 'auto',
                pr: 1,
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, pr: 4 }}>
                <Typography
                  variant="h5"
                  color="primary"
                  fontWeight={600}
                >
                  {isNewUser ? 'Novo Usuário' : 'Modificar Usuário'}
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Button type="submit" form="user-form" variant="contained" color="primary">Confirma</Button>

                  {(!isNewUser) && (
                    <Button type="button" variant="outlined" color="error" onClick={() => {
                      if (clickedRow) {
                        clickedRow.remove().draw(false);
                      }
                      seteditModalOpen(false);
                    }}>Remove Usuario
                    </Button>
                  )}

                </Box>
              </Box>

              <Box component="form"
                id="user-form"
                onSubmit={handleSubmit(onSubmit)}
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: 4,
                  mt: 2
                }}
              >

                {/* Left Column (User form) */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Controller
                    name="Active"
                    control={control}
                    render={({ field }) => (
                      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mt: 2 }}>
                        <Typography variant="subtitle1" fontWeight={500}>
                          Ativo
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Typography variant="body2">
                            {field.value === 'true' ? 'Sim' : 'Não'}
                          </Typography>
                          <Switch
                            checked={field.value === 'true'}
                            onChange={(e) => field.onChange(e.target.checked ? 'true' : 'false')}
                            color="primary"
                          />
                        </Box>
                      </Box>
                    )}
                  />

                  <Controller
                    name="Login"
                    control={control}
                    rules={{
                      required: "Login é obrigatório",
                      maxLength: {
                        value: 8,
                        message: "Máximo de 8 dígitos"
                      },
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Somente números são permitidos"
                      },
                      validate: (value) => {
                        if (value && String(value).length > 8) return "Máximo de 8 dígitos";
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Login"
                        fullWidth
                        variant="outlined"
                        type="tel"
                        error={!!errors.Login}
                        helperText={errors.Login ? String(errors.Login.message || "Login é obrigatório - Apenas números") : "Login é obrigatório - Apenas números"}
                      />
                    )}
                  />

                  <Controller
                    name="Name"
                    control={control}
                    rules={{
                      required: "Nome é obrigatório",
                      maxLength: {
                        value: 50,
                        message: "Máximo de 50 caracteres"
                      }
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Name"
                        fullWidth
                        variant="outlined"
                        error={!!errors.Name}
                        helperText={errors.Name ? String(errors.Name.message) : ""}
                      />
                    )}
                  />


                  <Controller
                    name="Senha"
                    control={control}
                    rules={{
                      required: false,
                      maxLength: 8,
                      validate: (value, formValues) => {
                        if (value === "" && formValues.Cartao === "") return "Preencha a senha ou o cartão (ou ambos)";
                        if (value === "*****" || value === "" || /^[0-9]*$/.test(value)) return true;
                        return "Apenas números";
                      }
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Senha"
                        fullWidth
                        type="text"
                        variant="outlined"
                        error={!!errors.Senha}
                        helperText={errors.Senha ? String(errors.Senha.message) : "Opcional. Se vazio, o acesso será apenas por cartão RFID."}
                        onFocus={(e) => {
                          const input = e.target as HTMLInputElement;
                          if (input.value === "*****") input.select();
                        }}
                        onInput={(e) => {
                          const input = e.target as HTMLInputElement;
                          if (input.value !== "*****") {
                            input.value = input.value.replace(/[^0-9]/g, '');
                            field.onChange(input.value);
                          }
                        }}
                      />
                    )}
                  />



                  <Controller
                    name="Cartao"
                    control={control}
                    rules={{
                      required: false,
                      maxLength: 10,
                      validate: (value, formValues) => {
                        if (value === "" && formValues.Senha === "") return "Preencha o cartão ou a senha (ou ambos)";
                        if (value === "*****" || value === "" || /^[0-9]*$/.test(value)) return true;
                        return "Apenas números";
                      }
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Cartao"
                        fullWidth
                        type="text"
                        variant="outlined"
                        error={!!errors.Cartao}
                        helperText={errors.Cartao ? String(errors.Cartao.message) : "Opcional. Se vazio, o acesso será apenas por senha."}
                        onFocus={(e) => {
                          const input = e.target as HTMLInputElement;
                          if (input.value === "*****") input.select();
                        }}
                        onInput={(e) => {
                          const input = e.target as HTMLInputElement;
                          if (input.value !== "*****") {
                            input.value = input.value.replace(/[^0-9]/g, '');
                            field.onChange(input.value);
                          }
                        }}
                      />
                    )}
                  />





                  <Controller
                    name="Type"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <FormControl fullWidth error={!!errors.Type}>
                        <InputLabel id="type-label">Tipo</InputLabel>
                        <Select
                          labelId="type-label"
                          value={field.value ?? ''}
                          onChange={field.onChange}
                          label="Tipo"
                        >
                          <MenuItem value="0">Operador</MenuItem>
                          <MenuItem value="1">Supervisor</MenuItem>
                          <MenuItem value="2">Manutenção</MenuItem>
                        </Select>
                        <FormHelperText>{"Tipo é obrigatorio"}</FormHelperText>
                      </FormControl>
                    )}
                  />

                  <Controller
                    name="Area"
                    control={control}
                    rules={{
                      required: false,
                      maxLength: {
                        value: 50,
                        message: "Máximo de 50 caracteres"
                      }
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Area"
                        fullWidth
                        variant="outlined"
                        error={!!errors.Area}
                        helperText={errors.Area ? String(errors.Area.message) : ""}
                      />
                    )}
                  />

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {accessMode === 'all_machines' || String(selectedType) === '1' || String(selectedType) === '2' ? (
                        <TextField
                          fullWidth
                          variant="outlined"
                          label="Máquinas"
                          value="Usuário pode usar todas as máquinas"
                          disabled
                        />
                      ) : (
                        <Controller
                          name="Machines"
                          control={control}
                          defaultValue={[]}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Autocomplete
                              multiple
                              disableCloseOnSelect
                              options={accessMode === 'selected_machine_types' ? machineTypeOptions : machineIdOptions}
                              value={field.value}
                              onChange={(event, newValue) => field.onChange(newValue)}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  label={accessMode === 'selected_machine_types' ? "Tipos de Máquinas" : "Máquinas"}
                                  placeholder="Selecionar"
                                />
                              )}
                            />
                          )}
                        />
                      )}
                    </Grid>
                  </Grid>

                </Box> {/* End Left Column */}

                {/* Right Column (Documents) */}
                {expirationCheckMode !== 'disabled' && (
                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant="h6" color="primary" fontWeight={600} textAlign="center">
                      Documentos
                    </Typography>

                    {expirationCheckMode === 'block' && (
                      <Alert severity="warning" sx={{ mb: 1, py: 0 }}>
                        O vencimento de documentos desabilita automaticamente o usuário.
                      </Alert>
                    )}
                    {expirationCheckMode === 'informational' && (
                      <Alert severity="info" sx={{ mb: 1, py: 0 }}>
                        O vencimento de documentos é monitorado apenas informativamente.
                      </Alert>
                    )}

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="subtitle2">Upload de Documento (PDF)</Typography>
                      <FormControl fullWidth>
                        <InputLabel>Tipo de Documento</InputLabel>
                        <Select
                          value={docType}
                          onChange={(e) => setDocType(e.target.value as string)}
                          label="Tipo de Documento"
                        >
                          <MenuItem value="ASO">ASO</MenuItem>
                          <MenuItem value="HABILITACAO">HABILITAÇÃO</MenuItem>
                          <MenuItem value="TREINAMENTO">TREINAMENTO</MenuItem>
                          <MenuItem value="OUTROS">OUTROS</MenuItem>
                        </Select>
                      </FormControl>

                      {docType === 'OUTROS' && (
                        <TextField
                          label="Especifique o Tipo"
                          fullWidth
                          variant="outlined"
                          value={docTypeOther}
                          onChange={(e) => setDocTypeOther(e.target.value)}
                        />
                      )}

                      <TextField
                        label="Validade"
                        type="date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={docValidade}
                        onChange={(e) => setDocValidade(e.target.value)}
                      />

                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                      >
                        {docFile ? docFile.name : 'Selecionar Arquivo PDF'}
                        <input
                          type="file"
                          accept="application/pdf"
                          hidden
                          onChange={(e) => {
                            if (e.target.files && e.target.files.length > 0) {
                              setDocFile(e.target.files[0]);
                            }
                          }}
                        />
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleFileUpload}
                        disabled={isUploading}
                        fullWidth
                      >
                        {isUploading ? 'Enviando...' : 'Fazer Upload'}
                      </Button>
                    </Box>

                    {userDocs.length > 0 && (
                      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography variant="subtitle2">Documentos Salvos</Typography>

                        <Box sx={{ mb: 1 }}>
                          {Array.from(new Set(userDocs.map(d => d.type))).map(type => {
                            // Find the latest document for this type based on uploaded_date
                            const docsOfType = userDocs.filter(d => d.type === type);
                            docsOfType.sort((a, b) => new Date(b.uploaded_date).getTime() - new Date(a.uploaded_date).getTime());
                            const latest = docsOfType[0];
                            return (
                              <Typography key={type as string} variant="body2">
                                • {type}: {latest.validade}
                              </Typography>
                            );
                          })}
                        </Box>

                        <FormControl fullWidth size="small">
                          <InputLabel>Baixar Documento</InputLabel>
                          <Select
                            value={downloadSelected}
                            onChange={(e) => setDownloadSelected(e.target.value as string)}
                            label="Baixar Documento"
                          >
                            {userDocs.map((doc) => (
                              <MenuItem key={doc._id} value={doc._id}>
                                {doc.type} - Validade: {doc.validade}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handleFileDownload}
                          disabled={!downloadSelected}
                          fullWidth
                        >
                          Download
                        </Button>
                      </Box>
                    )}

                  </Box>
                )}

              </Box>

            </Box>
          </S.ModalContainer>
        </Modal>
      )}

      <MassUploadModal
        open={massUploadModalOpen}
        onClose={() => setMassUploadModalOpen(false)}
        fields={[
          { name: 'Active', label: 'Ativo (true/false)' },
          { name: 'Login', label: 'Login', required: true },
          { name: 'Type', label: 'Tipo (0, 1 ou 2)' },
          { name: 'Name', label: 'Nome', required: true },
          { name: 'Area', label: 'Área' },
          { name: 'Machines', label: 'Máquinas (separadas por vírgula)' },
          { name: 'Senha', label: 'Senha' },
          { name: 'Cartao', label: 'Cartão RFID' },
        ]}
        requiredOneOf={[['Senha', 'Cartao']]}
        onUpload={(data) => {
          if (!table) return;
          const rowsToAdd = data.map((d: any) => {
            const activeStr = d['Active'] !== undefined ? String(d['Active']).toLowerCase() : '';
            const active = (d['Active'] !== undefined && d['Active'] !== "") ? (activeStr === 'true' || activeStr === '1' || activeStr === 'sim') : true;
            const login = d['Login'] || "";
            const type = d['Type'] || "0";
            const name = d['Name'] || "";
            const area = d['Area'] || "";

            let machines: string[] = [];
            if (d['Machines']) {
              machines = String(d['Machines']).split(',').map(m => m.trim()).filter(m => m !== "");
            }
            if (type === '1' || type === '2') {
              machines = [];
            }

            const pass = d['Senha'] || "";
            const card = d['Cartao'] || "";

            return [active, login, type, name, area, machines, pass, card];
          });

          let updatedCount = 0;
          let addedCount = 0;
          let ignoredCount = 0;
          const ignoredNames: string[] = [];

          rowsToAdd.forEach(newRow => {
            const login = String(newRow[1]).trim();
            const name = String(newRow[3]).trim();

            if (!login || !name) {
              ignoredCount++;
              if (!name && login) {
                ignoredNames.push(`Login: ${login} (Sem Nome)`);
              } else if (!login && name) {
                ignoredNames.push(name);
              } else {
                ignoredNames.push("Linha completamente vazia");
              }
              return; // Ignore lines with empty login or empty name
            }
            const indexes = table.rows().indexes().toArray();
            let foundIndex = -1;
            for (let i = 0; i < indexes.length; i++) {
              if (String(table.cell(indexes[i], 1).data()) === login) {
                foundIndex = indexes[i];
                break;
              }
            }

            if (foundIndex !== -1) {
              table.row(foundIndex).data(newRow);
              updatedCount++;
            } else {
              table.row.add(newRow);
              addedCount++;
            }
          });

          table.draw(false);

          let alertMessage = `${addedCount} usuários adicionados, ${updatedCount} atualizados e ${ignoredCount} ignorados na tabela!\nClique em "Salvar Modificações" para gravar no banco.`;

          if (ignoredCount > 0) {
            alertMessage += `\n\nIgnorados (sem login ou sem nome):\n- ${ignoredNames.slice(0, 10).join('\n- ')}`;
            if (ignoredCount > 10) {
              alertMessage += `\n... e mais ${ignoredCount - 10} outros.`;
            }
          }

          alert(alertMessage);
        }}
      />

    </DrawerHeader>
  );
}




